<!-- TODO: substituir progressivamente as modais mobile novas por app-modal-shell para unificar estrutura visual. -->
<app-modal-shell [isOpen]="aberto"
  [title]="titulo"
  [panelClass]="'w-[95vw] max-w-[31rem]'"
  [bodyClass]="'p-0'"
  [closeOnBackdropClick]="false"
  (fechado)="fechar.emit()">
  <div class="modal-acompanhamento-wrapper">

    <form class="modal-acompanhamento-form" (submit)="$event.preventDefault(); onSubmit()">

      <app-tabs [activeTab]="abaAtiva" (activeTabChange)="onAbaAtivaChange($event)">

        <!-- Aba: Acompanhamento -->
        <app-tab-panel tabId="acompanhamento" label="Acompanhamento">
          <div class="modal-acompanhamento-content">
            <div class="modal-acompanhamento-top grid grid-cols-1 gap-[0.74rem]">
              <app-prototype-select label="Componente curricular"
                placeholder="Selecione o componente curricular" [required]="true"
                [value]="formulario.componenteId" [disabled]="!!formulario.id" [clearable]="!formulario.id"
                [options]="componenteOptions" (valueChange)="onComponenteSelectChange($event)">
              </app-prototype-select>

              <div class="modal-acompanhamento-field">
                <label class="modal-acompanhamento-field__label">
                  <span>Data</span>
                  <span class="modal-acompanhamento-field__required">*</span>
                </label>

                <app-datepicker
                  [dataSelecionada]="dataSelecionada"
                  [referenceDate]="maxDate"
                  fieldClass="modal-acompanhamento-material-field w-full"
                  dateConstraintMode="past"
                  placeholder="Selecione a data"
                  (dateChange)="onDateChange($event)">
                </app-datepicker>
              </div>
            </div>

            <div class="modal-acompanhamento-alunos">
              <label class="modal-acompanhamento-field__label">
                <span>Aluno(s)</span>
                <span class="modal-acompanhamento-field__required">*</span>
              </label>
              <label *ngIf="!formulario.id"
                class="inline-flex items-center gap-[0.52rem] text-[13px] font-normal leading-[1.5] tracking-[0] text-gray-600 dark:text-gray-300">
                <button type="button" (click)="onSomentePublicoAlvoChange(!somentePublicoAlvo)"
                  class="relative inline-flex h-[1rem] w-[1.86rem] items-center rounded-full transition-colors"
                  [ngClass]="somentePublicoAlvo ? 'bg-blue-500' : 'bg-gray-300 dark:bg-gray-600'"
                  [attr.aria-pressed]="somentePublicoAlvo">
                  <span class="inline-block h-[0.76rem] w-[0.76rem] transform rounded-full bg-white transition-transform"
                    [ngClass]="somentePublicoAlvo ? 'translate-x-[0.94rem]' : 'translate-x-[0.1rem]'"></span>
                </button>
                Somente alunos com deficiência
              </label>

              <app-search-multiselect searchLabel="Buscar aluno" searchPlaceholder="Buscar aluno"
                selectPlaceholder="Selecione" clearSelectionLabel="Limpar seleção"
                selectAllLabel="Todos" clearFilteredLabel="Limpar todos os filtrados"
                loadingMessage="Carregando resultados" emptyMessage="Nenhum resultado encontrado"
                selectedCountLabel="Selecionados"
                [required]="true"
                [invalid]="campoAlunosInvalido"
                [options]="alunoOptions" [selectedValues]="formulario.alunoIds"
                [disabled]="!!formulario.id || !formulario.componenteId" [loading]="carregandoAlunos"
                [blocked]="false" [showSelectedBadges]="false"
                [blockedMessage]="''"
                (selectedValuesChange)="onAlunoIdsChange($event)">
              </app-search-multiselect>
            </div>

            <div class="modal-acompanhamento-observacoes">
              <label class="modal-acompanhamento-field__label">
                <span>Observações</span>
                <span class="modal-acompanhamento-field__required">*</span>
              </label>

              <mat-form-field appearance="fill" subscriptSizing="dynamic"
                class="modal-acompanhamento-material-field modal-acompanhamento-material-field--textarea w-full">
                <textarea matInput rows="6" [value]="formulario.observacao" [attr.maxlength]="limiteObservacao"
                  placeholder="Digite a observação" (input)="onObservacaoChange($any($event.target).value)"></textarea>
              </mat-form-field>

              <div class="mt-[1rem] text-right leading-none">
                <span class="text-[13px] font-normal leading-[1.5] tracking-[0]"
                  [ngClass]="observacaoCharCount > limiteObservacao ? 'text-red-600 dark:text-red-400' : 'text-[#7a8494] dark:text-gray-400'">
                  {{ observacaoCharCount }}/{{ limiteObservacao }} caracteres
                </span>
              </div>
            </div>

            <label
              class="modal-acompanhamento-publicar inline-flex items-center gap-[0.52rem] pt-0 text-[13px] font-normal leading-[1.5] tracking-[0] text-gray-600 dark:text-gray-300">
              <input type="checkbox" [checked]="formulario.publicar"
                (change)="onPublicarChange($any($event.target).checked)"
                class="h-[0.82rem] w-[0.82rem] rounded border-gray-300">
              Publicar no Pais e alunos
            </label>
          </div>
        </app-tab-panel>

        <!-- Aba: Anexos -->
        <app-tab-panel tabId="anexos" label="Anexos">
          <div class="modal-acompanhamento-content modal-acompanhamento-content--anexos">
            <app-anexos [anexos]="anexos" [carregando]="carregandoAnexos" [multiple]="true" [erro]="erroEnvio"
              (filesSelected)="onFilesSelected($event)" (remove)="onRemoveAnexo($event)"
              (download)="onDownloadAnexo($event)">
            </app-anexos>
          </div>
        </app-tab-panel>

        <!-- Aba: Dados adicionais -->
        <app-tab-panel tabId="dadosAdicionais" label="Dados adicionais">
          <div class="modal-acompanhamento-content">
            <div *ngIf="carregandoCampoAdicional" class="rounded-xl border border-dashed border-gray-200 dark:border-gray-700 px-4 py-3 text-sm text-gray-500 dark:text-gray-400">
              Carregando dados adicionais...
            </div>

            <div *ngIf="!carregandoCampoAdicional && !campoAdicional" class="rounded-xl border border-dashed border-gray-200 dark:border-gray-700 px-4 py-3 text-sm text-gray-500 dark:text-gray-400">
              Não existem dados adicionais para este registro.
            </div>

            <app-cpa-grid-bridge
              *ngIf="campoAdicional && !carregandoCampoAdicional"
              [config]="campoAdicional">
            </app-cpa-grid-bridge>
          </div>
        </app-tab-panel>

      </app-tabs>

      <!-- Rodapé com botões (sempre visível) -->
      <app-form-footer [salvando]="salvando" [podeSubmeter]="formularioValidoParaSalvar"
        [labelSalvando]="formulario.id ? 'SALVANDO EDIÇÃO...' : 'SALVANDO...'" (cancelar)="fechar.emit()"
        [mostrarExcluir]="!!formulario.id" (excluir)="excluir.emit()"
        (salvar)="onSubmit()">
      </app-form-footer>

    </form>
  </div>
</app-modal-shell>
